module.exports = __webpack_public_path__ + "2619557b557f9684e1c058a0bfd014de.svg";